// extracted by mini-css-extract-plugin
export default {"container":"PopUp_container__909WC","show":"PopUp_show__IEWhh","header":"PopUp_header__A8TAZ","body":"PopUp_body__+qppM"};